import { axios } from 'lib/axios';

export const emailOTPLogin = async (data) => {
  return await axios.post('/user/emailOTPLogin/login', data);
};
